import { render, staticRenderFns } from "./scheduleTransfer.vue?vue&type=template&id=0d6c6946&scoped=true&"
import script from "./scheduleTransfer.vue?vue&type=script&lang=js&"
export * from "./scheduleTransfer.vue?vue&type=script&lang=js&"
import style0 from "./scheduleTransfer.vue?vue&type=style&index=0&id=0d6c6946&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c6946",
  null
  
)

export default component.exports